<template>
	<div class="sansation button_link d-flex align-center justify-space-between menu_font pt-4 mb-3">
		<div class="d-inline justify-start flex-grow-1">
			<customIcon :name="moduleKey" class="d-inline mr-2 mb-n4 icon-size-header" />

			<div class="d-inline font-weight-black mr-4 pr-8 py-2" style="border-right: 1px solid #5f6062">
				{{ module_name }}
			</div>
			
			<div class="d-inline justify-start">
				<v-list-item 
					v-for="(item) in menu_items" 
					:key="item.title" 
					class="d-inline">

					<router-link
            v-if="item.title !== 'Resolution Request'"
						push
						:to="item.route" 
						class="button_link ma-0 px-4">
            <div class="d-inline">
              {{ item.title }}
            </div>
					</router-link>

          <v-menu 
            v-if="item.title === 'Resolution Request' && projectData.subProjects"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <div
                class="button_link ma-0 px-4 d-inline"
                v-bind="attrs"
                v-on="on"
              >
                {{ item.title }}
              </div>
            </template>
            <v-list
            >
              <v-list-item
                v-for="(resolution, i) in projectData.subProjects"
                :key="resolution.project_id"
                push
                :to="`/module_resolution/${resolution.module_key}/${resolution.project_id}`" 
              >
                <v-list-item-title>
                  Initialized {{ resolution.date_initialized.substr(0, 10) }} ({{ resolution.status === 'open' ? "In Progress" : resolution.status === 'review' ? "Submitted" : "Completed" }})
                </v-list-item-title>
              </v-list-item>
              <!-- <v-list-item
                @click="addResolution()"
              >
                <v-list-item-title>
                  New Resolution
                </v-list-item-title>
              </v-list-item> -->

            </v-list>          
          </v-menu>
				</v-list-item>
			</div>
      <div v-if="$router.currentRoute.name == 'module_questionnaire'">
          <div class="align-center caption font-weight-thin warning--text mt-3 ml-15" 
                style="cursor: pointer" 
                @click="techSupportDialog = true">
                Questionnaire not loading?
          </div>
      </div>
		</div>
    <v-dialog
			v-model="techSupportDialog"
			width="60%"
		>
			<v-card>
				<v-card-title class="headline primary darken-2 white--text py-4 mx-0 text-center">
					<div>Some people have reported not being able to load the questionnaire ...</div>
				</v-card-title>
	
				<v-card-text>
					<div class="d-block my-4">If you are experiencing this too, please "hard refresh" your browser by clicking the button below.</div>
					<div class="d-block mt-6 mb-4 text-center">
						<HardRefresh buttonText="Refresh Questionnaire" />
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
    import axios from "axios";
    import Cookie from "js-cookie";
    import appUrls from '../helpers/environment';
    import HardRefresh from './shared/hardRefresh'

    export default {
      name: 'ModuleMenu',

      components: {
        HardRefresh
      },
	    
      props: [
        'moduleKey',
        'projectId',
        'quickViewDeals',
        'triggerTip'
      ],

        data () {
            return {
                menu_items: [],
                module_name: '',
                active_class: Boolean,
                trigger_tip: false,
                project_title: null,
                authUser: {
                  id: String,
                  group: String,
                  is_secondary: Boolean
                },
                projectData: {},
                parentProjectData: {},
                module_info: {},
                techSupportDialog: false
            }
        },
        
		watch: {
            $route(to, from) {
                this.getModuleMenu()
                this.getModuleBasics()
            },

            triggerTip (val) {
            	this.trigger_tip = true
            	setTimeout(() => { this.trigger_tip = false; }, 3000);
            }

        },

		created () {
			setTimeout(() => { this.getModuleMenu() }, 500);
		},

		mounted () {
			this.getModuleBasics()
    },

        methods: {
            getModuleMenu: async function () {
				      try {
					      const prjId = this.projectId != '' ? this.projectId : 'undefined'
                const module_menu_info = await axios.get(`${appUrls.api}/api/module_menu/${this.moduleKey}/${prjId}`, {
                  headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                })

                if ( module_menu_info.data.outcome ) {
                  const menu_data = module_menu_info.data.menu;
						      this.project_title = menu_data.project_title

                  if (module_menu_info.data.menu.menu[0].module_key.includes('resolution')) {
                      await this.getProjectBasics()
                      await this.getSubProjects(this.parentProjectData.project_id)
                  }
                  
                  if (module_menu_info.data.menu.menu[0].module_key === 'entity-maintenance-program') {
                    await this.getSubProjects(this.projectId)
                  }

                  let show_questionnaire = true
                  if ( menu_data.secondary_users ) {
                    menu_data.secondary_users.forEach( user => {
                      if ( (user.user_id == Cookie.get('id')) && (!user.read && !user.write) ) {
                        show_questionnaire = false
                      }
                    })
                  }

                  const modulemenu = menu_data.menu
                  for ( let m in modulemenu ) {
                    if (modulemenu[m].module_key.includes('resolution')) {
                      if (modulemenu[m].route.includes('resolution')) {
                        modulemenu[m].route = `${modulemenu[m].route}/${this.projectData.module_key}/${this.projectData.project_id}`
                        continue
                      }
                      if (modulemenu[m].route.includes('roadmap') || modulemenu[m].route.includes('question')) {
                        modulemenu[m].route = `${modulemenu[m].route}/${this.parentProjectData.module_key}/${this.parentProjectData.project_id}`
                        continue
                      }
                    }
                    if (modulemenu[m].module_key === 'entity-maintenance-program' && modulemenu[m].title === '"Resolution Request"') {
                      modulemenu[m].route = `${modulemenu[m].route}/${this.projectData.module_key}/${this.projectData.project_id}`
                        continue
                    }
                    modulemenu[m].route = modulemenu[m].route.includes('/module_') ? `${modulemenu[m].route}/${modulemenu[m].module_key}/${this.projectId}` : modulemenu[m].route = `${modulemenu[m].route}`
                    modulemenu[m].title = this.$route.params.hasOwnProperty('lid') && modulemenu[m].title == 'Listings' ? `Back to Listings` : modulemenu[m].title
                  }

						if ( !show_questionnaire ) modulemenu.pop()

						this.menu_items = modulemenu
                    }
                } catch ( error ) {
                    console.log(error);
                }
            },

            getModuleBasics: async function () {
                try {
                  const moudle_basics = await axios.get(`${appUrls.api}/api/module_info/${this.moduleKey}`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                  })
                            
                  if ( moudle_basics.data.outcome ) {
                    this.module_name = moudle_basics.data.info.module_name;
                    if (this.module_name === 'Entity Maintenance Program Resolution') this.module_name = 'Entity Maintenance Program'

                    this.module_info = moudle_basics.data.info
                  }
                } catch ( error ) {
                    console.log(error);
                }
            },
            checkUser: async function () {
              try {
                const user_check = await axios.get(`${appUrls.api}/api/user_check`, {
                  headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                })
                
                if (user_check.data.outcome) {
                  this.authUser.id = user_check.data.user_data.id
                  this.authUser.group = user_check.data.user_data.group

                  return true
                } else {
                  console.log("user_check.data.message", user_check.data.message)
                }
              } catch (error) {
                console.log(error);
              }
            },

            getProjectBasics: async function () {
              try {
                const user_check = await this.checkUser()
                if (user_check) {
                  const current_project = await axios.get(`${appUrls.api}/api/current_project/${this.$route.params.pid}/${this.authUser.id}`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                  })

                  if (current_project.data.details) {
                    this.projectData = current_project.data.details
                    const parent_project = await axios.get(`${appUrls.api}/api/current_project/${current_project.data.details.parent_project_id}/${this.authUser.id}`, {
                      headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    })
                    this.parentProjectData = parent_project.data.details
                  }
                }
              } catch (error) {
                console.log("Failed to retrieve project basics: ", error)
              }
            },

            getSubProjects: async function(projectId) {
                try {
                  const user_check = await this.checkUser()
                  if (user_check) {
                    const response = await axios.post(`${appUrls.api}/api/sub_projects`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    data: {
                      user_id: this.authUser.id,
                      project_id: projectId
                    }
                    })
                    if (!response.data.subProjects) return
                    this.projectData.subProjects = response.data.subProjects.sort((a, b) => new Date(a.date_initialized) - new Date(b.date_initialized)) 
                  }
                } catch(error) {
                    console.log("Error getting subProjects: ", error)
                }
            },
            
            onBtnClick: function () {
            	this.$emit('quickViewDeals', !this.quickViewDeals)
            },

            handleBack: function () {
            	this.$router.push({
                	path: "/buyer_listings"
            	});
            },

            addResolution: async function() {
                let response = {}
                try {
                    response = await axios.post(`${appUrls.api}/api/add_submodule`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    data: {
                      user_id: this.authUser.id,
                      module: moduleInfo
                    }
                    })
                } catch (error) {
                    console.log("Error adding resolution: ", error)
                } finally {
                  this.$router.push({ path: `/module_resolution/${moduleInfo.sub_module_info.module_key}/${response.data.project_id}`});
                }
            },

        }
	}
</script>

<style scoped>
	.menu {
		/* background-color: #FCFCFC; rgb(217, 236, 238); or #CCEAED */
		border-bottom: 1px solid #CCEAED;
	}
	.menu_font {
		font-size: 1.1rem !important;
		font-weight: 400;
		/* letter-spacing: .025em !important; */
		line-height: 1.7rem;
	}
	.return_link {
		font-size: 1.2rem;
		text-decoration: none;
		/* mdi-keyboard-backspace */
	}

	.icon-size-header {
        width: 3rem;
    }

	.v-application .title {
		color: #5F6062;
		font-family: 'SansationBold', sans-serif !important;
		font-size: 32px !important;
	}

	.v-application .button_link {
		text-decoration-line: none;
		color: #5F6062;
		font-size: 1.15rem !important;
		/* font-size: 18px; */
	}

	.v-application .router-link-active {
		position: relative;
		color: #0096A6;
		font-weight: 500;
		text-decoration-line: none;
	}

	.v-application .router-link-active::before {
		content: '';
		position: absolute;
		bottom: -22px;
		left: 0;
		right: 0;
		height: 4px;
		border-radius: 8px;
		background-color: #0096A6;
	}

	.manage-deals-button {
		font-family: 'SansationBold', sans-serif;
		/* font-size: 18px; */
		letter-spacing: 0;
		/* text-transform: uppercase; */
	}
</style>


// WEBPACK FOOTER //
// src/components/ModuleMenu.vue